export const INSTALLMENTS_LIST_PAGE_SIZE = 25;

export const DEFAULT_INSTALLMENTS_LIST_SORT = 'name';
